{
	"content": {
		"title": "Välj material som kräver deklarationer",
		"materialListLabel": "Material",
		"materialQuantityLabel": "Materialkvantitet ({{unit}})",
		"availableQuantityLabel": "Tillgänglig kvantitet ({{unit}})",
		"carbonSavingsLabel": "Koldioxidreduktioner ({{unit}} CO\u2082 ekv.)"
	},
	"summary": {
		"title": "Sammanfattning",
		"declarationTypeTitle": "Deklarationstyp",
		"customerProjectTitle": "Kundprojekt",
		"internalProjectOrProductTitle": "Internt projekt / produkt",
		"projectReferenceTitle": "Projektreferens",
		"materialHeaderTitle": "Material",
		"quantityHeaderTitle": "Kvantitet ({{unit}})",
		"totalTransferableCarbonReductionsTitle": "Allokerbara koldioxidreduktioner ({{unit}})",
		"nonTransferableCarbonReductionTitle": "Ej allokerbar koldioxidreduktion ({{unit}})"
	},
	"errorMessages": {
		"quantityRequired": "Kvantitet krävs",
		"quantityPositive": "Ange en positiv kvantitet.",
		"quantityLargerThanAvailable": "Minska kvantiteten till totalt tillgängligt",
		"savingsRequired": "Koldioxidreduktioner krävs",
		"fetchNotTransferedMaterialsError": "Det gick inte att hämta ej överförda material"
	},
	"submitTitle": "Lägg till i projekt",
	"backTitle": "Tillbaka"
}
